module.exports = __webpack_public_path__ + "zmenseni-prsou_7_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_7_before.jpg
// module id = 1290
// module chunks = 0